Vue.component('cards', {
  template: templates.cards,
  data() {
    return {
      model: {
        edit: false,
        card: {
          name: null,
          hp: 0,
          attack: 0,
          defence: 0,
          accuracy: 0,
          speed: 0,
          // New battle stats
          pAtk: 0,
          mAtk: 0,
          armor: 0,
          ward: 0,
          critChance: 5,
          critDamage: 150,
          stamina: 0,
          mana: 0,
          type: null,
          ability: null,
          trait: null,
          ultimate: false,
          variant: false,
          delta: false,
          active: false,
          image: null
        },
        cards: {
          
        },
        types: {
          
        },
        tiers: {
          '1': {
            name: 'Standard'
          },
          '2': {
            name: 'Ultra'
          },
          '3': {
            name: 'Legendary'
          }
        },
        abilities: {

        },
        traits: []
      }
    }
  },
  watch: {
    'model.card.image': function(newImage) {
      this.refreshImage(); 
    }
  },
  mounted() {
    const c = this;
    c.get();

    c.$root.$on('remove-existing-image', data => {

      c.removeCurrentFile(data);
    })

  },
  methods: {
    get() {
      const c = this;
      let data = {};

      cardService.get()
        .then(function (response) {
     
          for (let d of response.data) {
            d.image = [`${d.id}.png`];
            data[`${d.id}`] = d;
          }
          c.model.cards = data;
          c.$root.$emit('unlockCards', data);

          c.getTypes();
          c.getAbilities();
          c.getTraits();
        })
        .catch(function (error) {
          //console.log(error);
        });
    },
    getTypes() {
      const c = this;
      let data = {};

      typeService.get()
        .then(function (response) {
          for (let d of response.data) {
            data[`${d.id}`] = d;
          }
          c.model.types = data;
          // c.$root.$emit('types', data);
        })
        .catch(function (error) {
          //console.log(error);
        });
    },
    getAbilities() {
      const c = this;
      let data = {};

      abilityService.get()
        .then(function (response) {
          for (let d of response.data) {
            data[`${d.id}`] = d;
          }
          c.model.abilities = data;
          // c.$root.$emit('abilities', data);
        })
        .catch(function (error) {
          //console.log(error);
        });
    },
    getTraits() {
      const c = this;

      traitService.get()
        .then(function (response) {
          c.model.traits = response.data;
        })
        .catch(function () {
          //console.log('Failed to load traits');
        });
    },
    edit(id) {
      const c = this;
      let data = c.model.cards[`${id}`];

      console.log(data)

      if (id == c.model.card.id) {
        c.model.edit = false;
      } else {
        c.model.edit = true;
      }

      c.model.card = {
        id: id,
        name: data.name,
        hp: data.hp,
        attack: data.attack,
        defence: data.defence,
        accuracy: data.accuracy,
        speed: data.speed,
        // New battle stats
        pAtk: data.pAtk || data.attack,
        mAtk: data.mAtk || 0,
        armor: data.armor || data.defence,
        ward: data.ward || 0,
        critChance: data.critChance || 5,
        critDamage: data.critDamage || 150,
        stamina: data.stamina,
        mana: data.mana,
        type: data.type,
        ability: data.ability,
        trait: data.trait || null,
        ultimate: data.ultimate,
        variant: data.variant,
        delta: data.delta,
        active: data.active,
        image: data.image
      }
    },
    add() {
      const c = this;
      c.model.edit = true;
    },
    save() {
      const c = this;
      const data = c.model.card;

      if (!data.name) {
        utils.alert.error('Name is required');
        return;
      }

      if (data.active && (data.hp == 0 || data.attack == 0 || data.defence == 0 || data.accuracy == 0 || data.speed == 0)) {
        utils.alert.error('HP, Attach, Defence, Speed and Accuracy are required to activate a card.');
        return;
      }
      
      if (data.exotic) data.tier = 8;
      else if (data.delta) data.tier = 10;
      else if (data.variant) data.tier = 9;

      cardService.save(data)
        .then(function (response) {

          if (data.id) {
            c.model.cards[`${data.id}`] = data;
          } else {
            data.id = response.data.id;
            c.model.cards[`${data.id}`] = data;
          }

          c.reset();

          utils.alert.success('Saved!');
          
        })
        .catch(function (error) {
          utils.alert.error('Failed to save.');
        });
    },
    upload() {
      const c = this;

      let data = new FormData();
      data.append('file', this.$refs.file.files[0]);
      data.append('type', 'cards');
      data.append('id', c.model.card.id);

      uploadService.uploadFile(data)
        .then(function (response) {
          utils.alert.success('File uploaded!');
          get();
        })
        .catch(function (error) {
          utils.alert.error('File failed to uploaded.');
        });
    },
    reset() {
      const c = this;
      c.model.edit = false;

      c.model.card = {
        name: null,
        hp: 0,
        attack: 0,
        defence: 0,
        accuracy: 0,
        speed: 0,
        // New battle stats
        pAtk: 0,
        mAtk: 0,
        armor: 0,
        ward: 0,
        critChance: 5,
        critDamage: 150,
        stamina: 0,
        mana: 0,
        type: null,
        ability: null,
        ultimate: false,
        variant: false,
        delta: false,
        active: false
      }
    },
    handleCardImageUpload(data){
      const c = this;
      const newImage = [`${data.id}.png?t=${Date.now()}`]; // cache-bust timestamp

      c.model.card.image = newImage;

      // Use $set so Vue detects the nested change and re-renders the table row
      c.$set(c.model.cards[`${data.id}`], 'image', newImage);

      c.refreshImage();
    },
    refreshImage() {
      const c = this;
      const imageUrl = `${c.getCardUrl()}${c.model.card.image}`;
      
      c.checkImageExists(imageUrl).then(exists => {
        if (!exists) {
          c.model.card.image = null; 
          c.model.cards[`${c.model.card.id}`].image = null
        }
      });
    },
    checkImageExists(url) {
      return new Promise((resolve) => {
        const img = new Image();
        img.src = url;
        img.onload = () => resolve(true);
        img.onerror = () => resolve(false);
      });
    },
    handleCardVfxUpload(data){
      const c = this;
      const filename = data.filename || `${data.id}.${data.extension}`;
      c.model.card.vfx = [filename];
      c.model.cards[`${data.id}`].vfx = [filename];
    },
    selectCardFlag(flag) {
      const c = this;
      const flags = ['ultimate', 'variant'];
      if (c.model.card[flag]) {
        flags.forEach(f => { if (f !== flag) c.model.card[f] = false; });
      }
    },
    getCardUrl(){
      const c = this;
      const url = `${root}/images/cards/`;
      return url;

    },
    getVfxUrl(){
      return `${root}/vfx/`;
    },
     removeCurrentFile(data){
      const c = this;
      const id = c.model.card.id;

      uploadService.deleteFile('cards', id, data.image)
        .then(function (response) {
          c.model.card.image = null;
          c.$set(c.model.cards[`${id}`], 'image', null); // ← add this
          utils.alert.success('File Removed!');
        })
        .catch(function (error) {
          utils.alert.error(error);
        });
    },

  }
});